import { getAccommodationQueryOptions } from '../accommodation/accommodationQueries';

import JmrService from './jmrService';

// **** Queries **** //

// **** Mutations **** //

export const getJmrMutationOptions = {
  associateInfo: {
    update: (accommodationId: number) => ({
      mutationFn: JmrService.updateAssociateInfo,
      meta: {
        invalidates: [getAccommodationQueryOptions.accommodationDetails(accommodationId).queryKey],
        successMessage: 'Associate information updated successfully',
      },
    }),
  },
};
